export default __webpack_public_path__ + "static/media/Emergency_cut.43db167d.jpg";